module.exports = __webpack_public_path__ + "img/xanter.e405afe7.svg";